import React from "react";
import { Navigate } from "react-router-dom";
import { hasPermission } from "./permissionStorage";

/**
 * Route guard: only renders children when the user's group grants `permission`.
 */
export default function PermissionRoute({ permission, children, redirectTo = "/dashboard" }) {
  if (!permission || !hasPermission(permission)) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
}
